import { render } from "./CoordinatorOJTPartner.vue?vue&type=template&id=fa2f312e"
import script from "./CoordinatorOJTPartner.vue?vue&type=script&lang=js"
export * from "./CoordinatorOJTPartner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__